import { render, staticRenderFns } from "./PartnerLogin.vue?vue&type=template&id=6dd017f8&"
import script from "./PartnerLogin.vue?vue&type=script&lang=js&"
export * from "./PartnerLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports